import BreadcrumbTrail from 'components/breadcrumbs/breaducrumtrail';
import React from 'react';

const DataPanel = ({ feature, level = 'state', onBack, canGoBack }) => {
    return (
        <div className='d-flex flex-column gap-3'><div>
  <BreadcrumbTrail feature={feature} onBack={onBack} /></div>
  <div>
  {feature && (
    <div className="bg-white " style={{ margin: 0, textAlign: 'left' }}>
      <p className="color-black m-0 p-0" style={{ fontSize: '0.9rem', color: '#666' }}>
        {feature.geo_level == 'State' ? 'State / UT' : feature.geo_level}
      </p>
      <h3 style={{ fontSize: '3rem', fontWeight: 600 }}>
        {feature.name || 'Feature'}
      </h3>
      <p className="m-0 color-dark-blue f-14">{feature.description}</p>

      {feature.static_data && Object.keys(feature.static_data).length > 0 && (
        <pre className="color-black m-0 px-4 py-2">
          <ul
            className="d-flex flex-wrap list-unstyled gap-3"
            style={{ margin: 0, padding: 0 }}
          >
            {Object.entries(feature.static_data)
              .filter(([key, value]) => key !== '' && value !== null)
              .map(([key, value]) => (
                <li key={key} className="d-flex flex-column me-5 mb-0 f-14">
                  <span className="text-md-start text-dark">{key}:</span>
                  <span className="text-md-start text-secondary">{String(value)}</span>
                </li>
              ))}
          </ul>
        </pre>
      )}
    </div>
  )}
</div>
</div>

    );
};

export default DataPanel;
